import React from 'react';
import DisplayImage1 from '../../Images/DisplayImage1.png'
export default function DisplayImage() {
    return (
        <img src={DisplayImage1} alt="Image description" style={{ width: '100%' }} />
    );
}
